import React from 'react';

import { Text } from '@/ui/typography';

import { useTheme } from '../theme';

interface WizardStepProps {
  stepNumber?: number;
  title: string;
  onClick?: () => void;
  isActive?: boolean;
}

export const WizardStep = (props: WizardStepProps) => {
  const {
    colors,
    componentProperties: { header },
  } = useTheme();

  const handleClick = props.onClick;

  return (
    <button
      css={{
        display: 'flex',
        gap: '16px',
        cursor: 'pointer',
        position: 'relative',
        touchAction: 'manipulation',
        ['&:focus:after']: {
          transform: 'scaleX(1)',
          transformOrigin: 'right',
          '[dir="rtl"] &': {
            transformOrigin: 'left',
          },
        },
        ['&:after']: {
          content: "''",
          display: 'block',
          position: 'absolute',
          backgroundColor: `${colors.textPrimary}`,
          height: '1px',
          width: '100%',
          bottom: '-4px',
          willChange: 'transform',
          transform: 'scaleX(0)',
          transformOrigin: 'left',
          insetInlineStart: '0',
          transition: 'transform 0.3s ease-in-out',
          '[dir="rtl"] &': {
            transformOrigin: 'right',
          },
        },
        ['@media all and (max-width: 730px)']: header?.wizard?.step?.mobile,
        ['@media all and (max-width: 359px)']: {
          display: 'none',
        },
        span: {
          opacity: props.isActive ? 1.0 : 0.8,
          ...header?.wizard?.step,
          ['@media all and (max-width: 730px)']: header?.wizard?.step?.mobile,
          ...(props.isActive ? header?.wizard?.step?.active : {}),
        },
        ...header?.wizard?.step,
        ...(props.isActive ? header?.wizard?.step?.active : {}),
        // Prevent duplicate opacity application; should only be added to <span>
        opacity: 1,
      }}
      role="button"
      onClick={handleClick}
      aria-label={`Go to ${props.title}`}
      tabIndex={0}
    >
      {props.stepNumber && (
        <Text
          style="bodySmall"
          fontFamily={
            header?.wizard?.step?.fontFamily ??
            header?.wizard?.step?.active?.fontFamily
              ? 'inherit'
              : undefined
          }
        >
          {props.stepNumber}
        </Text>
      )}
      <Text
        style="bodySmall"
        fontFamily={
          header?.wizard?.step?.fontFamily ??
          header?.wizard?.step?.active?.fontFamily
            ? 'inherit'
            : undefined
        }
      >
        {props.title}
      </Text>
    </button>
  );
};

export default WizardStep;
